module.exports = __webpack_public_path__ + "static/media/Botero.a1ad61d8.usdz";